import { IAdminUser } from '../interfaces/adminUser';
import create from 'zustand';
import { devtools } from 'zustand/middleware';

export interface IAuthState {
  user: IAdminUser | null;
  initialized: boolean;
  setUser: (user: IAdminUser | null) => void
};

export interface IAuthLoggedInState extends Omit<IAuthState, 'user'> {
  user: IAdminUser;
}

export const useAuthState = create<IAuthState>()(devtools((setState, getState) => ({
  user: null,
  initialized: false,
  setUser: (user) => setState({ user, initialized: true }),
})));

export const useAuthLoggedIn = () => {
  const state = useAuthState();
  return state as IAuthLoggedInState;
};

